export default {
  path: '/deposit',
  title: '押金管理',
  icon: 'th-list',
  children: [{
    path: '/deposit/index',
    title: '押金管理',
    icon: 'th-large'
  }]
};